export default "__VITE_ASSET__a3fbac78__"